module.exports = __webpack_public_path__ + "static/media/gnsLogo.31d5cd49.png";